/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const healthRiskSummarySchema = z.object({
  healthLevel: z.enum(['HEALTHY', 'NEEDS_ATTENTION', 'ACTION_REQUIRED', 'DONE']),
  itemIds: z.array(z.int()),
});
